import { render, staticRenderFns } from "./account_settings.vue?vue&type=template&id=45512cf0&scoped=true"
import script from "./account_settings.vue?vue&type=script&lang=js"
export * from "./account_settings.vue?vue&type=script&lang=js"
import style0 from "./account_settings.vue?vue&type=style&index=0&id=45512cf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45512cf0",
  null
  
)

export default component.exports